<template>
  <div>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="RULES"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="Location" prop="branchLocationId">
        <SelectLocation
          v-model="form.branchLocationId"
          :initial-datas="form.branchLocation ? [form.branchLocation] : null"
          :select-props="{
            value: form.branchLocationId || undefined,
            placeholder: 'Choose location',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Process users" prop="processUserIds">
        <SelectUser
          v-model="form.processUserIds"
          :initial-datas="form.processUsers"
          :variables-query="{ hasEmployee: undefined }"
          :select-props="{
            mode: 'multiple',
            value: form.processUserIds || undefined,
            placeholder: 'Choose users',
          }"
        />
      </a-form-model-item>
    </a-form-model>
    <div style="text-align: right;">
      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button
        type="primary"
        icon="save"
        :loading="loadingBtn"
        @click="onSubmit"
      >
        Save
      </a-button>
    </div>
  </div>
</template>
<script>
import SelectUser from "@/components/common/user/select";
import SelectLocation from "@/components/common/branchLocation/select";
import query from "./query.define";

const RULES = {
  branchLocationId: [
    { required: true, message: "Required", trigger: "change" },
  ],
  // processUserIds: [{ required: true, message: "Required", trigger: "change" }],
};
export default {
  components: { SelectUser, SelectLocation },
  props: {
    categoryId: {
      type: String,
      required: true,
    },
    close: {
      type: Function,
      default: () => {},
    },
    refreshAfterCreated: {
      type: Function,
      default: () => {},
    },
    refreshAfterUpdated: {
      type: Function,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      RULES,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { ...this.item },
      loadingBtn: false,
    };
  },
  watch: {
    item() {
      this.form = { ...this.item };
    },
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.form?.id) {
            this.updateItem();
          } else {
            this.createItem();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    async createItem() {
      this.loadingBtn = true;
      try {
        const result = await this.$apollo.mutate({
          mutation: query.createHelpdeskProcessUser,
          variables: {
            ...this.form,
            categoryId: this.categoryId,
          },
        });
        this.refreshAfterCreated(result?.data?.createHelpdeskProcessUser);
        this.$notification.success({
          message: "Success",
          description: "Create success!",
        });
      } catch (err) {
        console.error("err", err);
        this.$notification.error({
          message: "Error",
          description: "Create error!",
        });
      }
      this.close();
      this.loadingBtn = false;
    },
    async updateItem() {
      this.loadingBtn = true;
      try {
        const result = await this.$apollo.mutate({
          mutation: query.updateHelpdeskProcessUser,
          variables: {
            ...this.form,
            categoryId: this.categoryId,
          },
        });
        this.refreshAfterUpdated(result?.data?.updateHelpdeskProcessUser);
        this.$notification.success({
          message: "Success",
          description: "Update success!",
        });
      } catch (err) {
        console.error("err", err);
        this.$notification.error({
          message: "Error",
          description: "Update error!",
        });
      }
      this.close();
      this.loadingBtn = false;
    },
  },
};
</script>
